import client from '@/client/apiClient';

export default class OauthService {
  static getAccessToken(authorizationCode) {
    return client
      .get(`/oauth/token/${authorizationCode}`)
      .then((response) => response.data);
  }

  static refreshCurrentUser() {
    return client
      .get('/user/refresh')
      .then((response) => response.data);
  }
}
